module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/images/tab-bg_disabled.fcb8b539.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/images/tab-bg_disabled.png
// module id = 3102
// module chunks = 11